import React, { useRef } from 'react';
import DataGrid, {
  Button as GridButton,
  Column,
  DataGridRef,
  Grouping,
  Toolbar,
  Item,
  Pager,
  Paging,
  SearchPanel,
  Selection,
  HeaderFilter,
  Export,
  DataGridTypes
} from 'devextreme-react/data-grid';
import { RenderCellTelphone } from '../../utils/dataGridUtilities';
import './CurrentEmergenzaListaAssistitiPanel.scss';
import { useCurrentEmergenzaAssistitiDataSource } from '../../datasources/CurrentEmergenzaAssistitiDataSource';
import EmergenzaAssistitoCompletaPopup, { EmergenzaAssistitoCompletaPopupHandle } from './EmergenzaAssistitoCompletaPopup';
import { ColumnButtonClickEvent } from 'devextreme/ui/data_grid';
import { Button, TextBox } from 'devextreme-react';
import AssistitoEditPopup, { AssistitoEditPopupHandle } from '../assistitoEdit/AssistitoEditPopup';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

type Props = {
  emergenzaId: string;
}

export type EmergenzaListaAssistenzePanelHandle = {}

const CurrentEmergenzaListaAssistitiPanel: React.ForwardRefRenderFunction<EmergenzaListaAssistenzePanelHandle, Props> = (props, ref) => {
  const gridRef = useRef<DataGridRef>(null);
  const dataSource = useCurrentEmergenzaAssistitiDataSource();
  const completaRef = useRef<EmergenzaAssistitoCompletaPopupHandle>(null);
  const assistitoEditRef = useRef<AssistitoEditPopupHandle>(null);

  const openNavigatorWithFallback = (address: string) => {
    const encoded = encodeURIComponent(address);
    const geoUrl = `geo:0,0?q=${encoded}`;
    const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encoded}`;

    let didRedirect = false;

    // Fallback dopo 1s se non si è aperta l'app
    const fallbackTimeout = setTimeout(() => {
      if (!didRedirect) {
        window.location.href = fallbackUrl;
      }
    }, 1000);

    // Prova ad aprire l'app di navigazione
    window.location.href = geoUrl;

    // Dopo 2s, blocca il fallback
    setTimeout(() => {
      didRedirect = true;
      clearTimeout(fallbackTimeout);
    }, 2000);
  };

  const openGoogleMaps = (address: string) => {
  if (!address) return;
  const encoded = encodeURIComponent(address);
  const url = `https://www.google.com/maps/search/?api=1&query=${encoded}`;
  window.open(url, '_blank');
};


  const handleSearch = (e: any) => {
    const value = e.value;
    const grid = gridRef.current?.instance();
    if (grid) {
      grid.searchByText(value);
    }
  };

  const showChiusura = (e: ColumnButtonClickEvent) => {
    completaRef.current?.show(e.row?.data.id);
  }

  const refreshGrid = () => gridRef.current?.instance().refresh();

  const RenderAnagField = (cellData: any) => {
    //console.log("RenderAnagField", cellData);
    return (<a href={`#`} className="dx-link" onClick={(e) => assistitoEditRef.current?.show(cellData.data.assistito.id)}>
      {cellData.value}
    </a>)
  };

  const RenderGeoField = (cellData: any) => {
    //console.log("RenderAnagField", cellData);
    return (<a href={`#`} className="dx-link" onClick={(e) => openGoogleMaps(cellData.value)}>
      {cellData.value}
    </a>)
  };

  const onExporting = (e: DataGridTypes.ExportingEvent) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Main sheet');

  exportDataGrid({
    component: e.component,
    worksheet,
    autoFilterEnabled: true,
  }).then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ElencoAssistiti.xlsx');
    });
  });
};

  return (
    <React.Fragment>
      <DataGrid
        id='gridContainer'
        ref={gridRef}
        dataSource={dataSource}
        allowColumnReordering={true}
        rowAlternationEnabled={true}
        showBorders={true}
        width="100%"
        height="100%"
        onExporting={onExporting}
      >
        <Grouping autoExpandAll={true} />
        <HeaderFilter visible={true} allowSearch={true} />
        <SearchPanel
          visible={true}
          width={240}
          placeholder="Search..." />
        <Column type='buttons' alignment='left' width={40}>
          <GridButton
            icon='card'
            hint=''
            onClick={showChiusura}
          />
          {/* <GridButton
            icon='globe'
            hint='Apri indirizzo'
            onClick={(e) => openNavigatorWithFallback(`${e.row?.data.assistito.residenzaIndirizzo}, ${e.row?.data.assistito.residenzaNumeroCivico}, ${e.row?.data.assistito.residenzaComune},${e.row?.data.assistito.residenzaProvincia}`)}
          /> */}
        </Column>
        <Column dataField="assistito.nomeCompleto" caption='Assitito' cellRender={RenderAnagField} width={200} />
        <Column dataField="assistito.indirizzoResidenzaCompleto" caption='Indirizzo' hidingPriority={2} cellRender={RenderGeoField} />
        <Column dataField="assistito.telefono" caption='Telefono' cellRender={RenderCellTelphone} hidingPriority={3} width={130} />
        <Column dataField="assistito.cellulare" caption='Cellulare' cellRender={RenderCellTelphone} hidingPriority={4} width={130} />

        <Pager
          visible={true}
          allowedPageSizes={'auto'}
          showPageSizeSelector={false}
        />
        <Paging defaultPageSize={10} />
        {/* <Selection mode="single" /> */}

        <Toolbar>
          {/* <Item location="before">
          <div className="informer">
            <div className="count">{308}</div>
            <span>Totale</span>
          </div>
        </Item>
        <Item location="before">
          <div className="informer">
            <div className="count">{45}</div>
            <span>Da soccorrere</span>
          </div>
        </Item> */}
          <Item location="before">
            <TextBox
              placeholder="Cerca..."
              mode="search"
              onValueChanged={handleSearch}
              width={240}
            />
          </Item>

 <Item location="after" name='exportButton'></Item>
          <Item location="after">
            <Button
              icon='refresh'
              stylingMode="text"
              onClick={refreshGrid}
            />
          </Item>

        </Toolbar>
           <Export enabled={true}  />
      </DataGrid>

      <EmergenzaAssistitoCompletaPopup ref={completaRef} emergenzaId={props.emergenzaId} onDataChanged={refreshGrid} />
      <AssistitoEditPopup ref={assistitoEditRef} readOnly={true} />
    </React.Fragment>
  );
}

export default React.forwardRef(CurrentEmergenzaListaAssistitiPanel);
